import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const TOKEN_KEY = "autotube_token";

const api = axios.create({
    baseURL: API,
    withCredentials: true,
    headers: { "x-api-key": process.env.REACT_APP_ORCH_API_KEY || "" },
});

// Attach the session token as a Bearer header fallback (works even when
// third-party cookies are blocked).
api.interceptors.request.use((config) => {
    const t = localStorage.getItem(TOKEN_KEY);
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

// On auth failure, bounce to the login screen.
api.interceptors.response.use(
    (r) => r,
    (error) => {
        const status = error?.response?.status;
        const url = error?.config?.url || "";
        if (status === 401 && !url.includes("/auth/")) {
            localStorage.removeItem(TOKEN_KEY);
            if (!window.location.pathname.startsWith("/login")) {
                window.location.href = "/login";
            }
        }
        return Promise.reject(error);
    }
);

export default api;
